import { Form } from "@redriver/cinnamon-mui";
import { ContactStatus, enumOptionsArray } from "constants/enums";

const ContactStatusDropdown = (props) => (
  <Form.Dropdown options={enumOptionsArray(ContactStatus)} {...props} />
);

export default ContactStatusDropdown;
